import React, { memo, useEffect, useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import { useMutation } from '@apollo/react-hooks'
import { OauthSender } from 'react-oauth-flow'
import queryString from 'query-string'
import { Loading } from 'components'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { LinkedinLoginMutation, StoreValue } from 'store'
import { AuthStore } from '../../reducer'
import { ReactComponent as LinkedinIcon } from 'assets/images/linkedin.svg'
import { TLinkedinProps, EAuthActionTypes, EAppStateActionTypes } from 'models'
import { LINKEDIN_URIS } from 'utils'

const LinkedinView = ({
	loading,
	toggle,
	redirect,
	dispatch,
	firebase: { instance: firebaseApp },
	storeDispatch,
}: TLinkedinProps) => {
	const history = useHistory()
	const location = useLocation()
	const { i18n } = useTranslation()
	const [fetching, setFetching] = useState(false)
	const queryStringData = queryString.parse(location.search)
	const [linkedinLoginMutationHandle] = useMutation(LinkedinLoginMutation)
	const linkedinLogin = (url: string) => () => {
		if (toggle) toggle(true)
		window.location.href = url
	}

	useEffect(() => {
		const fetchAccessCode = async () => {
			try {
				const { data }: any = await linkedinLoginMutationHandle({
					variables: {
						code: queryStringData.code,
					},
				})
				if (data && data.linkedinConnect) {
					await firebaseApp
						.auth()
						.signInWithCustomToken(data.linkedinConnect._ft)
						.then((firebaseUser: any) => {
							storeDispatch({
								type: EAppStateActionTypes.updateUser,
								user: data.linkedinConnect,
								firebaseUser,
							})
						})
						.catch((err: any) => {
							console.error(err)
						})
				} else {
					dispatch({
						type: EAuthActionTypes.authFailed,
					})
					history.replace(`/${i18n.language}/auth`)
				}
			} catch (error) {
				dispatch({
					type: EAuthActionTypes.authFailed,
				})
				history.replace(`/${i18n.language}/auth`)
			}
		}
		if (queryStringData.code && !fetching) {
			setFetching(true)
			fetchAccessCode()
		}
		// eslint-ignore-next-line
	}, [
		fetching,
		queryStringData,
		linkedinLoginMutationHandle,
		dispatch,
		history,
		i18n.language,
		storeDispatch,
		firebaseApp,
	])

	return redirect ? (
		<Loading size={48} />
	) : (
		<OauthSender
			authorizeUrl="https://www.linkedin.com/oauth/v2/authorization"
			clientId="785i1h8xo0ddmt"
			// @ts-ignore
			redirectUri={LINKEDIN_URIS[process.env.REACT_APP_ENVIRONMENT]}
			// state={{ language: i18n.language }}
			args={{
				scope: 'r_liteprofile r_emailaddress w_member_social',
			}}
			render={({ url }: { url: string }) => (
				<IconButton disabled={loading} onClick={linkedinLogin(url)}>
					<LinkedinIcon />
				</IconButton>
			)}
		/>
	)
}

const LinkedinViewWithAuthStore = (props: TLinkedinProps) => (
	<AuthStore keys={['dispatch']}>
		<LinkedinView {...props} />
	</AuthStore>
)
export default memo((props: TLinkedinProps) => (
	<StoreValue keys={['firebase', 'storeDispatch']}>
		<LinkedinViewWithAuthStore {...props} />
	</StoreValue>
))
